import { HTMLInputElement, html } from '@html-element-wrappers/input';
import { enableFocusVisible } from '../utils/focus-visible-polyfill.js';
import { css } from './toggle.css.js';
import { StyleResizeObserverMixin } from '../utils/style-resize-observer-mixin';

/**
 * 
 * @element slicesui-toggle
 * 
 * @fires change - Fires when 'checked' value changed
 * 
 * @prop {Boolean} [disabled=false] - If `true`, toggle cannot be clicked
 * @attr {Boolean} [disabled]
 * 
 * @prop {Boolean} [checked=false] - Whether the toggle is checked or not
 * @attr {Boolean} [checked]
 * 
 * @cssprop --slicesui-toggle-background
 * @cssprop --slicesui-toggle-color
 * @cssprop --slicesui-toggle-background--checked
 * 
 */
class SlicesUIToggle extends StyleResizeObserverMixin(HTMLInputElement) {

  constructor() {
    super();
    enableFocusVisible(this);
    this.observeAndSetStyles();
  }

  /**
   * @private
   */
  get styles() {
    return html`<style>${css}</style>`;
  }

  /**
   * @private
   */
  get template() {
    return html`<div>${super.template}</div>`;
  }

  /**
   * @private
   */
  get type() {
    return 'checkbox';
  }
  
}

window.customElements.define('slicesui-toggle', SlicesUIToggle);